import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import { MdLogout } from "react-icons/md";
import { TiHome } from "react-icons/ti";
import { MdOutlineOndemandVideo } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import styles from "./style.module.css";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { socket } from "../../socket/socket";
import { FiLock } from "react-icons/fi";
import { FaCaretRight } from "react-icons/fa";
import { FaCaretLeft } from "react-icons/fa";
import Lottie from "react-lottie";
import Modal from "@mui/material/Modal";
import feedBackJson from "../../assets/json/feedback.json";
import { BiLike } from "react-icons/bi";
import { BiDislike } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsModelOpen,
  setReviewPipelineId,
} from "../../redux/slice/reviewSlice";
import { message, Select } from "antd";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { getApi, postApi } from "../../services/apiService/fetchMethod";
import { setCreditScore } from "../../redux/slice/filterSlice";
import { AppBar } from "@mui/material";
import encrypt from "../../services/hash-service/encrypt-service";
import { clintUrl } from "../../services/apiService/baseUrl";
import getUserData from "../../utils/getUserData";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 3px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 3px)`,
  },
});
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));


function Sidebar({ outlet }) {
  let  {selectedProject}  = getUserData();
  selectedProject = selectedProject?.value;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [gpulist, setGpuList] = useState([]);
  const [selectedGpu, setSelectedGpu] = useState(null); 
  const handleClose = () => dispatch(setIsModelOpen(false));
  const { isModelOpen, reviewPipelineId } = useSelector(
    (state) => state.reviewReducer
  );
  const { selectedTabAll, creditScore } = useSelector((state) => state.filter);
  const navigate = useNavigate();
  const loaction = useLocation();
  let sidebarList = [
    { name: "Workspace", icon: <TiHome size={26} />, path: "/auth/workspace" },
    // {
    //   name: "Videos",
    //   icon: <MdOutlineOndemandVideo size={24} />,
    //   path: "/auth/videos",
    // },
    // {
    //   name: "Reports",
    //   icon: <TbReportAnalytics size={26} />,
    //   path: "/auth/reports",
    // },
    {
      name: "Change Password",
      icon: <FiLock size={22} />,
      path: "/auth/change-password",
    },

    { name: "Log Out", icon: <MdLogout size={26} />, path: "/" },
  ];
  // if (localStorage.getItem("Token")) {
  //   sidebarList.splice(3, 0, {
  //     name: "Change Password",
  //     icon: <FiLock size={22} />,
  //     path: "/auth/change-password",
  //   });
  // }
  const handleLogOut = () => {
    localStorage.clear();
    navigate("/");
  };
  useEffect(() => {
    function onConnect() {
      console.log("Socket connected✅");
    }
    function onDisconnect() {
      console.log("Socket Disconnected❌");
    }
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    // return () => {
    //   socket.disconnect();
    // };
  }, []);
  useEffect(() => {
    (async () => {
      if (localStorage.getItem("Token")) {
        const url = apiEndPoint().GET_CREDIT;
        const { data, status } = await getApi({ url });
        console.log(data, status);
        if (data?.data !== creditScore) {
          dispatch(setCreditScore(data?.data));
        }
      }
    })();
  }, [selectedTabAll]);
  useEffect(() => {
    (async () => {
      let url = apiEndPoint().GET_GPU;
      const { status, data } = await getApi({ url });
      if (status === 200) {
        setGpuList(data.data);
        let isTrue = data.data.some(
          (item) => item.value === localStorage.getItem("gpu")
        );
        if (!isTrue) {
          setSelectedGpu(data.data[0]?.value);
          localStorage.setItem("gpu", data.data[0]?.value);
        } else {
          setSelectedGpu(localStorage.getItem("gpu"));
        }
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      let url = apiEndPoint().GET_ALL_PROJECT + `?pratham=${true}`;
      let { data } = await getApi({ url });
      setProjectList(data?.data);
    })();
  }, []);
  const handleSelectProject = async (val) => {
    let project = projectList.filter(item=>item.value ===val)
    const url = apiEndPoint().CHANGE_PROJECT;
    const { status, data } = await postApi({
      url,
      params: {
        project: project[0],
      },
    });    
    if (status === 200) {
      localStorage.setItem("Token", data?.data?.accessToken);
      localStorage.setItem(
        "User",
        encrypt(
          JSON.stringify({
            firstName: data?.data?.firstName,
            lastName: data?.data?.lastName,
            email: data?.data?.email,
            profile_img: data?.data?.profile_img,
            projects: projectList,
          })
        )
      );
      if (data?.data?.selectedProject) {
        localStorage.setItem(
          "selectedProject",
          encrypt(JSON.stringify(data?.data?.selectedProject))
        );
      }
      localStorage.setItem(
        "modules",
        encrypt(JSON.stringify(data?.data?.modules))
      );
      window.location.reload();
    }
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 4,
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: feedBackJson,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const handleSubmitFeedback = async (val) => {
    try {
      const url = apiEndPoint().REVIEW_PIPELINE;
      const { data, status } = await postApi({
        url,
        params: { val, id: reviewPipelineId },
      });
      if (status === 200) {
        message.success(data?.message);
      } else {
        message.warning(data?.message);
      }
      dispatch(setIsModelOpen(false));
      dispatch(setReviewPipelineId(null));
    } catch (error) {
      message.error("Somthing went wrong");
      console.error(error);
    }
  };
  return (
    <Box sx={{ display: "flex" }}>
      <div
        className={styles.closeDiv}
        style={{ left: open ? "225px" : "50px" }}
        onClick={() => setOpen((pre) => !pre)}
      >
        {!open ? <FaCaretRight size={22} /> : <FaCaretLeft size={22} />}
      </div>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        style={{
          background: "#fff",
          height: "60px",
          paddingRight: "1rem",
          boxShadow:
            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            height: "60px",
          }}
        >
          <Select
            placeholder="Select a Project"
            size="large"
            value={selectedProject}
            onChange={handleSelectProject}
            options={projectList}
            style={{
              width: 200,
              marginRight: "1rem",
            }}
          />
          <Select
            placeholder="Select a Device"
            size="large"
            value={selectedGpu}
            onChange={(val) => {
              setSelectedGpu(val);
              localStorage.setItem("gpu", val);
              window.location.reload();
            }}
            options={gpulist}
            style={{
              width: 200,
            }}
          />
        </div>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <div className={styles.heraderDash}>
          <Link to="/auth/workspace">
            <img
              src="../../assets/newLogo2.png"
              alt="Logo"
              width={open ? 200 : 50}
              height={40}
              priority
              style={{ objectFit: "contain" }}
            />
          </Link>
        </div>
        <Divider />
        <List
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {sidebarList.map((item, I) => {
            return (
              <Link
                to={item.path}
                key={I}
                onClick={() =>
                  item.name === "Log Out" ? handleLogOut() : null
                }
                style={{ color: "black" }}
              >
                <div
                  className={`${
                    item.path === loaction.pathname
                      ? styles.activeLink
                      : styles.sidebarLink
                  }`}
                >
                  <div className={styles.boxLink}>
                    <div className={styles.iconBox}>{item.icon}</div>
                    {open ? <div> {item.name}</div> : null}
                  </div>
                </div>
              </Link>
            );
          })}
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        {/* {!notShow.includes(loaction.pathname) && (
          <div
            style={{
              marginBottom: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Radio.Group
              defaultValue={selectedTabAll}
              buttonStyle="solid"
              onChange={(e) => dispatch(setSelectedTabAll(e.target.value))}
            >
              <Radio.Button value="video">Video</Radio.Button>
              <Radio.Button value="camera">Camera</Radio.Button>
            </Radio.Group>
            <div>
              {" "}
              <div className="card1">
                <svg
                  className="wave1"
                  viewBox="0 0 1440 320"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0,256L11.4,240C22.9,224,46,192,69,192C91.4,192,114,224,137,234.7C160,245,183,235,206,213.3C228.6,192,251,160,274,149.3C297.1,139,320,149,343,181.3C365.7,213,389,267,411,282.7C434.3,299,457,277,480,250.7C502.9,224,526,192,549,181.3C571.4,171,594,181,617,208C640,235,663,277,686,256C708.6,235,731,149,754,122.7C777.1,96,800,128,823,165.3C845.7,203,869,245,891,224C914.3,203,937,117,960,112C982.9,107,1006,181,1029,197.3C1051.4,213,1074,171,1097,144C1120,117,1143,107,1166,133.3C1188.6,160,1211,224,1234,218.7C1257.1,213,1280,139,1303,133.3C1325.7,128,1349,192,1371,192C1394.3,192,1417,128,1429,96L1440,64L1440,320L1428.6,320C1417.1,320,1394,320,1371,320C1348.6,320,1326,320,1303,320C1280,320,1257,320,1234,320C1211.4,320,1189,320,1166,320C1142.9,320,1120,320,1097,320C1074.3,320,1051,320,1029,320C1005.7,320,983,320,960,320C937.1,320,914,320,891,320C868.6,320,846,320,823,320C800,320,777,320,754,320C731.4,320,709,320,686,320C662.9,320,640,320,617,320C594.3,320,571,320,549,320C525.7,320,503,320,480,320C457.1,320,434,320,411,320C388.6,320,366,320,343,320C320,320,297,320,274,320C251.4,320,229,320,206,320C182.9,320,160,320,137,320C114.3,320,91,320,69,320C45.7,320,23,320,11,320L0,320Z"
                    fill-opacity="1"
                  ></path>
                </svg>

                <div className="icon-container1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    stroke-width="0"
                    fill="currentColor"
                    stroke="currentColor"
                    className="icon1"
                  >
                    <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"></path>
                  </svg>
                </div>
                <div className="message-text-container1">
                  <p className="message-text1">Available Credit </p>
                  <p className="sub-text1">{creditScore?.credit_score}</p>
                </div>
              </div>
            </div>
          </div>
        )} */}
        <div style={{ marginTop: "4rem" }}>
          <Outlet />
        </div>
      </Box>
      <div>
        <Modal
          open={isModelOpen}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div>
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
            <div className={styles.centerText}>
              Thank you for reaching the end of our AI livestream. Your feedback
              is essential for us to improve.
            </div>
            <div className={styles.subText}></div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "1rem",
              }}
            >
              <button
                className={styles.likeBtn}
                style={{ marginRight: "1rem" }}
                onClick={() => handleSubmitFeedback(true)}
              >
                <BiLike size={24} />
              </button>
              <button
                className={styles.likeBtn}
                style={{ color: "red", marginLeft: "1rem" }}
                onClick={() => handleSubmitFeedback(false)}
              >
                <BiDislike size={24} />
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </Box>
  );
}

export default Sidebar;
